module.exports = __webpack_public_path__ + "static/media/image_18.2fe187bf.png";